import React from 'react';
import './ContributionBarChart.css';

interface Props {
  bars: [string, number][];
}

const BAR_COLORS: Record<string, string> = {
  'Audience pattern (CF)': '#1d4a32',
  'Next-watch pattern': '#9c6b1f',
  Genre: '#3f7a63',
  Language: '#7a9e8c',
  Channel: '#c98a3f',
  Format: '#b5545c',
  Cast: '#6b5b95',
  Synopsis: '#5b8a9e',
};

export default function ContributionBarChart({ bars }: Props) {
  const max = Math.max(...bars.map(([, v]) => v), 0.0001);

  return (
    <div className="contribution-chart">
      {bars.map(([label, value]) => (
        <div className="contribution-chart__row" key={label}>
          <span className="contribution-chart__label">{label}</span>
          <div className="contribution-chart__track">
            <div
              className="contribution-chart__fill"
              style={{
                width: `${(value / max) * 100}%`,
                background: BAR_COLORS[label] ?? 'var(--brand-forest)',
              }}
            />
          </div>
          <span className="contribution-chart__value">{value.toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}
